module.exports = __webpack_public_path__ + "78123d15b4718d2ed9cac332866a4735.svg";